import { Component } from '@angular/core';
import { PageContainerComponent } from '../../../layout/page-container/page-container.component';
import { SearchConfig } from '../../../model/api.model';
import { DataTableSchema } from '../../../model/dynamic-data-table.model';
import { Props, DynamicFormArray, FieldSelectedValue } from '../../../model/form.model';
import { TTENTenureTitle, TTENTenureProps, TTENTenureFilterSchema, TTENTenureTableSchema, TTENTenureSearchConfig } from '../../../model/tenure/tten-tenure.model';
import { TenureBaseComponent } from '../tenure-base/tenure-base.component';
import { FieldNames } from '../../../model/form-fields.model';
import { PaginatorService } from '../../../services/paginator-service.service';

@Component({
  selector: 'app-tten-tenure',
  standalone: true,
  imports: [PageContainerComponent],
  providers: [PaginatorService],
  templateUrl: './tten-tenure.component.html',
  styleUrl: './tten-tenure.component.scss'
})
export class TtenTenureComponent extends TenureBaseComponent {

  protected override data: string = TTENTenureTitle;
  protected override props: Props = TTENTenureProps;
  protected override filterSchema: DynamicFormArray = structuredClone(TTENTenureFilterSchema);
  protected override dataTableSchema: DataTableSchema = structuredClone(TTENTenureTableSchema);
  protected override searchConfig: SearchConfig = structuredClone(TTENTenureSearchConfig);

  override onControlValueChanged = (event: FieldSelectedValue) => {
    const field = this.filterSchema.FieldsArray.find((p) => p.fieldName === event.FieldName);
    if (field) {
      field.selectedValue = event.Value;
    }
    this.checkForAnyEmptyFields();
  }
  override onResetClicked = () => {
    const areaRegion = this.filterSchema.FieldsArray.find(x => x.fieldName === FieldNames['Area']);
    if (areaRegion) {
      areaRegion['displayName'] = 'Region'
      areaRegion['selectedValue'] = '';
      areaRegion['options'] = [...structuredClone(this.regionOption)]
    }
    this.filterSchema.FieldsArray = this.filterSchema.FieldsArray.map((field) => ({ ...field, selectedValue: field['defaultValue'] ? field['defaultValue'] : '' }));
    this.dataTableSchema.dataSource = [];
    this.resetSorting()
    this.dataTableSchema.inputFilter = '';
    this.checkForAnyEmptyFields();
  }
}
